import React from "react";

interface CustomHeaderProps {
  title: string;
  subtitle: string;
  className?: string;
}

export const CustomHeader: React.FC<CustomHeaderProps> = ({
  title,
  subtitle,
  className = "",
}) => (
  <div className={className}>
    <h3 className="text-2xl font-bold font-poppins text-black ">{title}</h3>
    <p className="text-gray-500 mb-1 leading-5">{subtitle}</p>
  </div>
);
